module.exports = __webpack_public_path__ + "static/media/PROFILE_SELF_CONTROL_MASTER.6c6cf2af.md";